import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import { SET_PROJECT_LIST } from "../constants";
import { formatProjects } from "./settingsActionsUtils";

export const fetchProjects = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.projects.list)
            .then((response) => {
                const projects = formatProjects(response.data);
                dispatch({
                    type: SET_PROJECT_LIST,
                    payload: keyBy(projects, "value"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};